<script>
  import {createEventDispatcher} from 'svelte'
  let menuOpen = false;
  let classOpenTopBar = 'menu-toggle-bar menu-toggle-bar--top';
  let classOpenMiddleBar = 'menu-toggle-bar menu-toggle-bar--middle';
  let classOpenBottomBar = 'menu-toggle-bar menu-toggle-bar--bottom';
  const dispatch = createEventDispatcher();
  const onClick = () => {
    menuOpen = !menuOpen;
    dispatch('clickMenu', menuOpen);
  }
</script>

<div class="container">
  <div class="menu-toggle" on:click={onClick}>
    <span class={menuOpen?`nav-open ${classOpenTopBar}`:classOpenTopBar}></span>
    <span class={menuOpen?`nav-open ${classOpenMiddleBar}`:classOpenMiddleBar}></span>
    <span class={menuOpen?`nav-open ${classOpenBottomBar}`:classOpenBottomBar}></span>
  </div>
</div>

<style>
.container {
  display: none;
  position: relative;
  padding: 1.8rem;
}

.menu-toggle {
  position: absolute;
  right: 1.5rem;
  top: 49%;
  transform: translate(0, -50%);
  height: 26px;
  width: 29px;

}
.menu-toggle:hover {
    color: #FDFDFD;
  }

.menu-toggle-bar {
  display: block;
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 0;
  width: 100%;
  height: 4px;
  border-radius: 4px;
  background-color: #FDFDFD;
  transition: all 0.3s ease;
  }

  .menu-toggle-bar.menu-toggle-bar--top {
    transform: translate(0, -8px);
  }
  .menu-toggle-bar.menu-toggle-bar--bottom {
    transform: translate(0, 8px);
  }
  .nav-open.menu-toggle-bar.menu-toggle-bar--top {
    transform: translate(0, 0) rotate(45deg);
  }
  .nav-open.menu-toggle-bar.menu-toggle-bar--middle {
    opacity: 0;
  }
  .nav-open.menu-toggle-bar.menu-toggle-bar--bottom {
    transform: translate(0, 0) rotate(-45deg);
  }
  @media  screen and (max-width: 812px) {
    .container {
      display: block;
    }
  }
</style>